import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DemioRegular from './demio-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DemioRegular {...validProps} />;
}
SvgComponent.iconName = 'demioRegular';

export const DemioRegularIcon = svgIconWrapper(SvgComponent);
